import FirebaseContext, {
  withFirebase,
  FeatureToggleListener
} from './context';
import Firebase from './firebase';

export default Firebase;

export { FirebaseContext, withFirebase, FeatureToggleListener };
